import * as actionTypes from "../actionTypes.js";

const initialState = {
  plans: [],
};

const billingReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_PLANS:
      return { ...state, plans: action.payload };

    default:
      return state;
  }
};

export default billingReducer;
